<ng-template #titleArea>
  @if (settings.adminSidenavUserBlock && !isMobile && (!hideMenuIcon || showSurveyDetailsBackButton)) {
    <span fxShow [fxHide.gt-sm]="!showMenuDesktop">
      @if (showSurveyDetailsBackButton) {
        <button mat-button type="button" (click)="goBackToManageSurvey()" class="sidenav-toggle">
          <mat-icon>arrow_back</mat-icon>
        </button>
      } @else {
        <button mat-button (click)="toggle()" class="sidenav-toggle">
          <mat-icon>menu</mat-icon>
        </button>
      }
    </span>
  }

    <span class="f-lg-30 ag-hero-title top-toolbar__title">{{ displayTitle }}</span>
</ng-template>

<ng-template #userInfo>
  <button
    mat-icon-button
    [matMenuTriggerFor]="userInfoMenu"
    #userInfoMenuTrigger="matMenuTrigger"
    class="centre-item profile-avatar-btn profile-badge-btn"
  >
    <input
      type="image"
      [src]="getProfilePhoto()"
      class="profile-photo"
      alt="User profile photo"
    />
  </button>

  <div class="top-menu-item">
    <mat-menu
      #userInfoMenu="matMenu"
      [overlapTrigger]="false"
      xPosition="before"
      class="app-dropdown account"
    >
      <span (mouseleave)="userInfoMenuTrigger.closeMenu()">
        <button mat-menu-item class="user-info">
          <span>{{ user?.email }} </span>
        </button>
        <div class="divider" fxHide.gt-xs></div>
        <a mat-menu-item (click)="logout()" (keyup.enter)="logout()" fxHide.gt-xs>
          <mat-icon class="mat-icon-sm icon-color">power_settings_new</mat-icon>
          <span>Sign Out</span>
        </a>
      </span>
    </mat-menu>
  </div>

  @if (displayUserName) {
    <div class="user-display-name mr-1" fxHide.xs>{{ displayUserName }}</div>
  }
  <button fxHide.xs mat-raised-button color="primary" class="field-height-button logout-btn" (click)="logout()">
    LOGOUT
  </button>
</ng-template>

<mat-toolbar-row
  fxLayoutAlign="space-between center"
  class="ag-hero top-toolbar theme-container admin-toolbar"
  [class.top-toolbar--survey-details]="isSurveyDetailsRoute"
  >
  @if (showMenuDesktop && !isMobile) {
    <div
      fxLayout="row"
      fxLayoutAlign="center center"
      >
      <ng-container *ngTemplateOutlet="titleArea"></ng-container>
    </div>
  } @else {
    @if (settings.adminSidenavUserBlock && !isMobile && (!hideMenuIcon || showSurveyDetailsBackButton)) {
      <span fxShow [fxHide.gt-sm]="!showMenuDesktop">
        @if (showSurveyDetailsBackButton) {
          <button mat-button type="button" (click)="goBackToManageSurvey()" class="sidenav-toggle">
            <mat-icon>arrow_back</mat-icon>
          </button>
        } @else {
          <button mat-button (click)="toggle()" class="sidenav-toggle">
            <mat-icon>menu</mat-icon>
          </button>
        }
      </span>
    }
    @if (showSurveyDetailsBackButton) {
      <div fxLayout="row" fxLayoutAlign="start center" class="top-toolbar__brand">
        <button
          mat-icon-button
          type="button"
          class="sidenav-toggle"
          aria-label="Back to Manage Surveys"
          (click)="goBackToManageSurvey()"
        >
          <mat-icon>arrow_back</mat-icon>
        </button>
        <span class="f-lg-30 ag-hero-title top-toolbar__title">{{ displayTitle }}</span>
      </div>
    } @else {
      <a
        [routerLink]="brandRouterLink"
        fxLayout="row"
        fxLayoutAlign="center center"
        class="logo-focusable top-toolbar__brand"
        >
        <img class="logo" src="assets/images/hero/logo.png" alt="Portal logo" />
        <span class="f-lg-30 ag-hero-title top-toolbar__title">{{ displayTitle }}</span>
      </a>
    }
  }

  @if (showMenuDesktop && !isMobile) {
    <div
      fxLayout="row"
      fxLayoutAlign="end center"
      >
      @if (!hideTerritorySelect) {
        <mat-form-field fxFlex="100px" appearance="outline" class="territory-select field-height-button store-badge" subscriptSizing="dynamic">
          <mat-select panelClass="territory-select-panel" [value]="territory" (selectionChange)="onTerritoryChange($event.value)">
            <mat-select-trigger>
              <span class="territory-select__value">
                <mat-icon>flag</mat-icon>
                <span>{{ territory }}</span>
              </span>
            </mat-select-trigger>
            <mat-option>
              <ngx-mat-select-search [formControl]="territoryFilterCtrl" placeholderLabel="Terr"
                noEntriesFoundLabel="No matching territory found">
                <mat-icon ngxMatSelectSearchClear>clear</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            @for (terr of filteredTerritories | async; track terr) {
              <mat-option [value]="terr">{{ terr }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      <ng-container *ngTemplateOutlet="userInfo"></ng-container>
    </div>
  } @else {
    @if (!hideTerritorySelect) {
      <mat-form-field fxFlex="100px" appearance="outline" class="territory-select field-height-button store-badge" subscriptSizing="dynamic">
        <mat-select panelClass="territory-select-panel" [value]="territory" (selectionChange)="onTerritoryChange($event.value)">
          <mat-select-trigger>
            <span class="territory-select__value">
              <mat-icon>flag</mat-icon>
              <span>{{ territory }}</span>
            </span>
          </mat-select-trigger>
          <mat-option>
            <ngx-mat-select-search [formControl]="territoryFilterCtrl" placeholderLabel="Terr"
              noEntriesFoundLabel="No matching territory found">
              <mat-icon ngxMatSelectSearchClear>clear</mat-icon>
            </ngx-mat-select-search>
          </mat-option>
          @for (terr of filteredTerritories | async; track terr) {
            <mat-option [value]="terr">{{ terr }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    <button
      mat-button
      [matMenuTriggerFor]="userInfoMenu"
      #userInfoMenuTrigger="matMenuTrigger"
      class="profile-trigger profile-badge-btn"
    >
      <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="4px">
        <input
          type="image"
          [src]="getProfilePhoto()"
          class="profile-photo"
          alt="User profile photo"
          />
        <mat-icon class="profile-chevron">expand_more</mat-icon>
      </div>
    </button>
    <div class="top-menu-item">
      <mat-menu
        #userInfoMenu="matMenu"
        [overlapTrigger]="false"
        xPosition="before"
        class="app-dropdown account"
      >
        <span (mouseleave)="userInfoMenuTrigger.closeMenu()">
          <button mat-menu-item class="user-info">
            <span>{{ user?.email }} </span>
          </button>
          <div class="divider" fxHide.gt-xs></div>
          <a mat-menu-item (click)="logout()" (keyup.enter)="logout()" fxHide.gt-xs>
            <mat-icon class="mat-icon-sm icon-color">power_settings_new</mat-icon>
            <span>Sign Out</span>
          </a>
        </span>
      </mat-menu>
    </div>
    @if (displayUserName) {
      <div class="user-display-name mr-1" fxHide.xs>{{ displayUserName }}</div>
    }
    <button fxHide.xs mat-raised-button color="primary" class="field-height-button logout-btn" (click)="logout()">
      LOGOUT
    </button>
  }
</mat-toolbar-row>
